import { Actions } from 'actions/clientRankings';
import { AxiosError } from 'axios';
import { DeepReadonly } from 'utility-types';
import { IRanking } from '@pec/aion-ui-core/interfaces/ranking';

export type State = DeepReadonly<{
  [organizationId: string]: {
    isFetching: boolean;
    clientRankings: IRanking | null;
    error: AxiosError | null;
  };
}>;

export const initialState: State = {};

export function reducer(state: State = initialState, action: Actions): State {
  switch (action.type) {
    case 'FETCH_CLIENT_RANKINGS_REQUEST':
      return {
        ...state,
        [action.organizationId]: {
          isFetching: true,
          clientRankings: null,
          error: null
        }
      };
    case 'FETCH_CLIENT_RANKINGS_SUCCESS':
      return {
        ...state,
        [action.organizationId]: {
          isFetching: false,
          clientRankings: action.payload,
          error: null
        }
      };
    case 'FETCH_CLIENT_RANKINGS_FAILURE':
      return {
        ...state,
        [action.organizationId]: {
          isFetching: false,
          clientRankings: null,
          error: action.error
        }
      };
    default:
      return state;
  }
}
